export default "__VITE_ASSET__CMrKduVC__"